import { Component } from "@angular/core";
import { ILoadingOverlayAngularComp } from "ag-grid-angular";
import { EspGridLoadingParams } from "../../../components/grid-loading/grid-loading.component";

/** Plan grids' loading overlay: skeleton on first load (when asked), then the spinner. */
@Component({
  standalone: false,
  selector: "wfm-plan-loading-overlay",
  templateUrl: "./plan-loading-overlay.component.html"
})
export class PlanLoadingOverlayComponent implements ILoadingOverlayAngularComp {
  params?: EspGridLoadingParams;

  agInit(params: EspGridLoadingParams): void {
    this.params = params;
  }
}
